import React, { useEffect, useState } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import StatementDocument from "./StatementDocument";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx"; 

const StatementPreview = ({
  statementDataRecordsFromAPI,
  statementDataFromAPI,
  handleCloseStatement,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [statementData, setStatementData] = useState([]);
  const [pdfReady, setPdfReady] = useState(false);

  useEffect(() => {
    setPdfReady(false);
    const timer = setTimeout(() => setPdfReady(true), 500);
    return () => clearTimeout(timer);
  }, [statementDataRecordsFromAPI]);

  const isEmpty =
    !statementDataRecordsFromAPI ||
    Object.values(statementDataRecordsFromAPI).length === 0;

  useEffect(() => {
    if (location.state) {
      console.log(
        "location.state in statements preview:",
        location.state.statementData,
      );
      setStatementData(location.state.statementData.apiData);
    }
  }, [location]);

  const apiData = statementDataFromAPI?.apiData || [];
  console.log("Statement data from preview", apiData);

  const trnData = statementDataFromAPI?.apiData[0]?.TRN || "";

  // 2. Define the Excel Export Function
  const exportToExcel = () => {
    if (apiData.length === 0) {
      alert("No data available to export");
      return;
    }

    // Create a new workbook and worksheet
    const worksheet = XLSX.utils.json_to_sheet(apiData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Statement");

    // Generate buffer and trigger download
    XLSX.writeFile(workbook, "statement_export.xlsx");
  };

  // const onBackToStatements = () => {
  //   // navigate('/statements')
  //   handleCloseStatement();
  // };

  const onBackToStatements = () => {
    console.log("Back clicked");
    console.log("handleCloseStatement:", handleCloseStatement);

    handleCloseStatement?.();
  };

  return (
    <div className="mx-4">
      {/* Top Bar */}
      <div className="flex justify-between items-center my-4">
        <h2 className="text-xl font-semibold">Statement Preview</h2>
        <div className="flex gap-2">
          <button
            onClick={exportToExcel}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded transition-colors"
          >
            Export to Excel
          </button>
          <button
            className="text-white px-4 py-1 rounded bg-gray-800 hover:bg-black transition-colors"
            onClick={onBackToStatements}
          >
            Back
          </button>
        </div>
      </div>

      <div className="flex flex-col items-center h-screen">
        <div className="w-full h-full border border-gray-300 mb-4">
          {!pdfReady && (
            <div className="flex flex-col items-center justify-center h-full gap-3">
              <div className="w-9 h-9 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
              <p className="text-gray-500 text-sm">Preparing statement...</p>
            </div>
          )}

          {pdfReady && isEmpty && (
            <div className="flex flex-col items-center justify-center h-full gap-3">
              <span className="text-5xl">📄</span>
              <p className="text-gray-700 font-semibold text-lg">
                No Records Found
              </p>
              <p className="text-gray-400 text-sm">
                Try adjusting the date range or account selection.
              </p>
              <button
                onClick={onBackToStatements}
                className="mt-2 bg-gray-800 text-white px-5 py-1.5 rounded hover:bg-black transition-colors text-sm"
              >
                Go Back
              </button>
            </div>
          )}

          {pdfReady && !isEmpty && (
            <PDFViewer width="100%" height="100%">
              <StatementDocument
                statementDataFromAPI={statementDataFromAPI}
                statementDataRecordsFromAPI={statementDataRecordsFromAPI}
                accountData={statementDataFromAPI}
                statementData={statementData}
                trnData={trnData}
              />
            </PDFViewer>
          )}
        </div>

        {/* Download button — only show when data exists */}
        {pdfReady && !isEmpty && (
          <div className="mt-4 mb-12">
            <PDFDownloadLink
              document={
                <StatementDocument
                  statementDataFromAPI={statementDataFromAPI}
                  statementDataRecordsFromAPI={statementDataRecordsFromAPI}
                  statementData={statementData}
                />
              }
              fileName="statement.pdf"
              className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
            >
              {({ loading }) =>
                loading ? "Generating PDF..." : "Download PDF Statement"
              }
            </PDFDownloadLink>
          </div>
        )}
      </div>
    </div>
  );
};

//   return (
//     <div className="mx-4">
//       <div className="flex justify-between items-center my-4">
//         <h2 className="text-xl font-semibold">Statement Preview</h2>

//         {/* Button Container */}
//         <div className="flex gap-2">
//           {/* 3. The Excel Button */}
//           <button
//             onClick={exportToExcel}
//             className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded transition-colors"
//           >
//             Export to Excel
//           </button>

//           <button
//             className="text-white px-4 py-1 rounded bg-gray-800 hover:bg-black transition-colors"
//             onClick={onBackToStatements}
//           >
//             Back
//           </button>
//         </div>
//       </div>

//       <div className="flex flex-col items-center h-screen">
//         <div className="w-full h-full border border-gray-300 mb-4">
//           <PDFViewer width="100%" height="100%">
//             <StatementDocument
//               statementDataFromAPI={statementDataFromAPI}
//               statementDataRecordsFromAPI={statementDataRecordsFromAPI}
//               accountData={statementDataFromAPI}
//               statementData={statementData}
//             />
//           </PDFViewer>
//         </div>

//         <div className="mt-4 mb-12">
//           <PDFDownloadLink
//             document={
//               <StatementDocument
//                 statementDataFromAPI={statementDataFromAPI}
//                 statementDataRecordsFromAPI={statementDataRecordsFromAPI}
//                 statementData={statementData}
//               />
//             }
//             fileName="statement.pdf"
//             className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
//           >
//             {({ loading }) =>
//               loading ? "Generating PDF..." : "Download PDF Statement"
//             }
//           </PDFDownloadLink>
//         </div>
//       </div>
//     </div>
//   );
// };

export default StatementPreview;
